"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const item_1 = require("./item");
require("@hotmart/cosmos/dist/nav/nav.css");
const Nav = ({ children, id, className, 'data-test': dataTest, type = 'tabs' }) => {
    const classes = (0, classnames_1.default)({
        'hot-nav--tabs': type === 'tabs',
        'hot-nav--pills': type === 'pills'
    }, className);
    return ((0, jsx_runtime_1.jsx)("hot-nav", { id: id, "data-test": dataTest, class: classes, children: children }));
};
Nav.Item = item_1.NavItem;
exports.default = Nav;
